$(document).ready(function () {
  $(".product-selector_block").click(function () {
    var currentMode = $(".product-selector_outer.active_block").attr("data");
    var currentIndex = $(this).attr("data-index");

    $(".product-selector_block").removeClass("active");
    $(this).addClass("active");
    $('.product-selector_block[data-index="' + currentIndex + '"]').addClass(
      "active",
    );

    var indexOpt = $(this).attr("data-index");
    $(".product_atc-refills").addClass("hided");
    $('.product_atc-refills[data="' + indexOpt + '"]').removeClass("hided");

    $(".cta-note.changeble").addClass("hided");
    $('.cta-note.changeble[data-id="' + indexOpt + '"]').removeClass("hided");
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  function getStorageValue(key) {
    const value = localStorage.getItem(key);

    if (!value) return null;

    try {
      let parsed = JSON.parse(value);

      if (Array.isArray(parsed)) {
        return parsed.join(",");
      }

      if (parsed && typeof parsed === "object") {
        return Object.keys(parsed)
          .map(function (id) {
            return parsed[id];
          })
          .join(",");
      }
    } catch (e) {
      return value;
    }

    return value;
  }

  function getAbsParams() {
    let absParams = "";

    function addAbsParam(name, value) {
      if (value) {
        absParams += "&" + name + "=" + encodeURIComponent(value);
      }
    }

    addAbsParam("cc_custom__abs_id", getStorageValue("abs-id"));
    addAbsParam("cc_custom__abs_groups", getStorageValue("abs-test-groups"));
    addAbsParam(
      "cc_custom__abs_shipping_groups",
      getStorageValue("abs-shipping-test-groups"),
    );
    addAbsParam(
      "cc_custom__abs_redirect_groups",
      getStorageValue("abs-redirect-test-groups"),
    );
    addAbsParam(
      "cc_custom__abs_theme_groups",
      getStorageValue("abs-theme-test-groups"),
    );
    addAbsParam(
      "cc_custom__abs_template_groups",
      getStorageValue("abs-template-test-groups"),
    );

    return absParams;
  }

  $(".product-selector_atc_coc_sel").click(function () {
    var newUrl = $(".product-selector_outer.active_block")
      .find(".product-selector_block.active")
      .attr("data-coc-link");
    window.location.href = newUrl + getAbsParams();
  });

  $(".product-selector_atc_coc").click(function () {
    var newUrl = $(this).attr("data-coc-link");
    window.location.href = newUrl + getAbsParams();
  });

  $(".product-selector_atc").click(function () {
    if ($(this).attr("data-mode-champs") == "true") {
      var newUrl = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-coc-url");

      window.location.href = newUrl + getAbsParams();
    } else {
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var currentSellingPlan = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-selling-plan");

      // Bundle gift: add a second product in the same request when the
      // configured variant (and purchase type) is selected
      var giftEnabled = $(this).attr("data-gift-enabled") == "true";
      var giftId = $(this).attr("data-gift-id");
      var giftMode = $(this).attr("data-gift-mode");
      var activeIndex = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-index");
      if (
        giftEnabled &&
        giftId &&
        activeIndex == $(this).attr("data-gift-position") &&
        (giftMode == "both" || giftMode == mode)
      ) {
        var mainItem = { id: currentId, quantity: 1 };
        if (mode == "sub") {
          mainItem.selling_plan = currentSellingPlan;
        }

        // Same form-encoded format as the single-item add below, so cart
        // apps that watch /cart/add.js see it the same way
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { items: [mainItem, { id: giftId, quantity: 1 }] },
          dataType: "json",
          success: function () {},
          error: function (xhr) {
            // Gift unavailable (e.g. sold out): still add the main variant
            console.warn("Bundle gift add failed, adding main item only", xhr.responseText);
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: mainItem,
              dataType: "json",
              success: function () {},
              error: function () {
                alert("Error adding item to the cart.");
              },
            });
          },
        });
        return;
      }

      if (mode == "sub") {
        data = {
          id: currentId,
          quantity: 1,
          selling_plan: currentSellingPlan,
        };
      } else {
        data = {
          id: currentId,
          quantity: 1,
        };
      }

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {},
        error: function () {
          alert("Error adding item to the cart.");
        },
      });
    }
  });

  // Check referrer for Facebook domains
  var referrer = document.referrer.toLowerCase();

  var isFacebookAd =
    referrer.includes("facebook.com") ||
    referrer.includes("m.facebook.com") ||
    referrer.includes("l.facebook.com") ||
    referrer.includes("instagram.com");

  // Optional: also check common FB ad URL params
  var urlParams = new URLSearchParams(window.location.search);
  var productSub = false;
  if ($(".pp_var_autoship").attr("sub-pre") == "true") {
    var productSub = true;
  }

  // alert(productSub);

  var hasFbParams =
    urlParams.has("fbclid") ||
    urlParams.get("utm_source") === "facebook" ||
    urlParams.get("utm_source") === "instagram";

  if (isFacebookAd || hasFbParams || productSub == true) {
  } else {
    // Trigger click
    $(".pp_var_autoship").trigger("click");
  }

  $(".mpb_sub-cell").click(function () {
    var $scope = $(this).closest(".mpb_selector");

    $scope.find(".mpb_sub-cell").removeClass("active");
    $(this).addClass("active");

    var index = $(this).attr("data-index");
    $scope.find(".mpb_once-atc").addClass("hided");
    $scope
      .find('.mpb_once-atc[data-index="' + index + '"]')
      .removeClass("hided");

    $scope.find(".mpb_small-atc-footer").addClass("hided");
    $scope
      .find('.mpb_small-atc-footer[data-index="' + index + '"]')
      .removeClass("hided");
  });

  $(".mpb_main-atc").click(function () {
    var $btn = $(this);
    var $scope = $btn.closest(".mpb_selector");
    $btn.find("h4").html("ADDING");

    var currentId = $scope.find(".mpb_sub-cell.active").attr("data-id");
    var sellingId = $scope
      .find(".mpb_sub-cell.active")
      .attr("data-selling-plan");
    var data = {
      id: currentId,
      quantity: 1,
      selling_plan: sellingId,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        $btn.find("h4").html("ADD TO CART");
      },
      error: function () {
        alert("Error adding item to the cart.");
        $btn.find("h4").html("ADD TO CART");
      },
    });
  });

  $(".mpb_once-atc").click(function () {
    var currentId = $(this).attr("data-id");

    var data = {
      id: currentId,
      quantity: 1,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {},
      error: function () {
        alert("Error adding item to the cart.");
      },
    });
  });

  var $trialDeliveryDate = $(".trial_delivery-date");
  if ($trialDeliveryDate.length) {
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var deliveryDays = parseInt($trialDeliveryDate.attr("data-days"), 10) || 1;

    var newDate = new Date();
    var businessDays = 0;
    while (businessDays < deliveryDays) {
      newDate.setDate(newDate.getDate() + 1);
      if (newDate.getDay() !== 0) {
        businessDays++;
      }
    }

    var formattedDate =
      days[newDate.getDay()] +
      ", " +
      newDate.getDate() +
      " " +
      months[newDate.getMonth()];
    $trialDeliveryDate.text(formattedDate);
  }

  $(".trial_offer-variant").click(function () {
    var $row = $(this);
    if ($row.hasClass("active")) {
      return;
    }

    $(".trial_offer-variant").removeClass("active");
    $row.addClass("active");

    var price = $row.attr("data-price");
    var comparePrice = $row.attr("data-compare-price");
    var savings = $row.attr("data-savings");
    var hasSavings = $row.attr("data-has-savings") === "true";

    $(".trial_offer-final-price").text(price);
    $(".trial_offer-compare-price").text(comparePrice);
    $(".trial_offer-savings-amount").text(savings);
    $(".trial_offer-savings").toggle(hasSavings);
    $(".trial_atc-price").text(price);

    $(".trial_atc-button")
      .attr("data-id", $row.attr("data-id"))
      .attr("data-selling-plan", $row.attr("data-selling-plan"));
  });

  $(".trial_atc-button").click(function () {
    var $button = $(this);
    if ($button.hasClass("is-adding")) {
      return;
    }

    var originalLabel = $button.find(".trial_atc-button-label").text();
    $button.addClass("is-adding");
    $button.find(".trial_atc-button-label").text("Adding...");

    var currentId = $button.attr("data-id");
    var sellingId = $button.attr("data-selling-plan");
    var data = {
      id: currentId,
      quantity: 1,
    };
    if (sellingId) {
      data.selling_plan = sellingId;
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {},
      error: function () {
        alert("Error adding item to the cart.");
      },
      complete: function () {
        $button.removeClass("is-adding");
        $button.find(".trial_atc-button-label").text(originalLabel);
      },
    });
  });
});

// Kaching cart: gift lines don't link to the product page. CSS turns off
// pointer events on the links; this also blocks keyboard (Enter) activation.
// Keep the handle list in sync with assets/buy-page-stylesheet.css
(function () {
  var GIFT_HANDLES = ["probiotic-kombucha-gel-by-whispore"];
  var giftLinkSelector = GIFT_HANDLES.map(function (handle) {
    return '.kaching-cart-item[data-product-handle="' + handle + '"] a';
  }).join(",");

  document.addEventListener(
    "click",
    function (event) {
      if (event.target instanceof Element && event.target.closest(giftLinkSelector)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
